var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiddleCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 66,
    viewBox: "0 0 152 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M136.863 34.2808C134.516 34.2808 132.299 34.8481 130.317 35.8476C130.487 35.0237 130.578 34.1727 130.578 33.2948C130.578 26.4872 125.259 20.9764 118.687 20.9764C116.001 20.9764 113.524 21.9084 111.529 23.4752C107.67 13.426 98.2172 6.32128 87.1347 6.32128C82.0889 6.32128 77.3821 7.79355 73.3923 10.3464C71.9973 4.41679 66.8602 0 60.7061 0C54.0957 0 48.6588 5.07863 47.7722 11.6701C46.2989 11.3594 44.7734 11.1973 43.2088 11.1973C30.4574 11.1973 20.118 21.9084 20.118 35.1182C20.118 36.2663 20.2223 37.3874 20.3788 38.495C19.6487 38.1033 18.8403 37.8602 17.9537 37.8602C15.0461 37.8602 12.6862 40.2914 12.6471 43.29C12.0604 43.1954 11.4737 43.1279 10.8609 43.1279C4.86327 43.1279 0 48.166 0 54.3792C0 60.5925 4.86327 65.6306 10.8609 65.6306H136.863C145.22 65.6306 152 58.6069 152 49.9489C152 41.3044 145.22 34.2808 136.863 34.2808Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleCloud);
export default __webpack_public_path__ + "static/media/Middle Cloud.2d8218e5f0614a25a42a7ef9a3c838a1.svg";
export { ForwardRef as ReactComponent };